import { SkeletonProps as MuiSkeletonProps } from '@mui/material';
import MuiSkeleton from '@mui/material/Skeleton';
import { useTheme } from '@mui/material/styles';

export const Skeleton = (props: MuiSkeletonProps) => {
  const theme = useTheme();
  return (
    <MuiSkeleton
      {...props}
      sx={{
        backgroundColor: theme.brandV2.colors.treadGray7,
        borderRadius: '8px',
        ...props.sx,
      }}
    />
  );
};

Skeleton.displayName = 'Skeleton';
